import styled from 'styled-components';

export const Wrapper = styled.div`
  box-shadow: 0 4px 7px rgba(31, 39, 56, 0.1);
  border-radius: 5px;
  background: #ffffff;
  padding: 24px;
`;
